export default "__VITE_ASSET__543fd8ac__"